"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import {
  createPdfParseBrowserTools,
  findModelContext,
  registerPdfParseBrowserTools,
} from "@/lib/webmcp";

export function WebMCPProvider() {
  const router = useRouter();
  useEffect(() => {
    const context = findModelContext(document, navigator);
    if (!context) return;
    return registerPdfParseBrowserTools(
      context,
      createPdfParseBrowserTools({
        fetch: window.fetch.bind(window),
        navigate: (path) => router.push(path),
      }),
    );
  }, [router]);
  return null;
}
